import { AwsUi } from '../../../core/runtime/src';
export var LiveRegion = function (_a) {
    var message = _a.message, _b = _a.atomic, atomic = _b === void 0 ? true : _b;
    // When mithril or react updates a node, NVDA registers
    // many separate live region updates and announces them all.
    // This way we are guaranteed to update the live region only once
    // https://github.com/nvaccess/nvda/issues/7996
    var liveRegionDidUpdate = function (element) {
        if (element) {
            element.textContent = message;
        }
    };
    return (AwsUi.__createElement("div", { className: "awsui-util-hide", "aria-live": "assertive", "aria-atomic": atomic ? 'true' : 'false', componentDidUpdate: liveRegionDidUpdate, lifecycleKey: "awsui-live-region" }));
};
//# sourceMappingURL=index.js.map